module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/cy-bdc1fde27ba14b2afa3b59bec603759f.svg";